//The hierarchy of content starts from the Home page all the way to the Contact page

const coreTeam = [
  {
    id: 1,
    name: "Lt. Col. Mollah Mezbahuddin Ahmed, Principal",
    designation: "Chief Advisor",
  },
  {
    id: 2,
    name: "Asoke Kumar Roy, Vice Principal",
    designation: "Advisor",
  },
  {
    id: 3,
    name: "Md. Majibur Rahman, Assistant Professor (ICT)",
    designation: "Moderator",
  },
  {
    id: 4,
    name: "Gopal Kumar Agarwala, Lecturer (ICT)",
    designation: "Co-Moderator",
  },
  {
    id: 5,
    name: "Rezaul Karim, Lecturer (ICT)",
    designation: "Co-Moderator",
  },
  {
    id: 6,
    name: "Sofikul Islam, Lecturer (ICT)",
    designation: "Co-Moderator",
  },
  {
    id: 7,
    name: "Khandaker Nahida Siddiqa, Lecturer (ICT)",
    designation: "Co-Moderator",
  },
];

const foundingTeam = [
  {
    id: 1,
    name: "Jayed Saifullah Rafi",
    designation: "President",
  },
  {
    id: 2,
    name: "Arif Sadique",
    designation: "Vice President",
  },
  {
    id: 3,
    name: "Ibrarur Rahman Choudhury",
    designation: "General Secretary",
  },
  {
    id: 4,
    name: "Raihan Ahmed",
    designation: "Associate General Secretary",
  },
  {
    id: 5,
    name: "Syeda Anika Ferdose",
    designation: "Assistant General Secretary",
  },
  {
    id: 6,
    name: "Ehsanur Rahman Rhythm",
    designation: "Secretary of Programming & Web Development",
  },
  {
    id: 7,
    name: "Kazi Mashrur Haque Mahin",
    designation: "Secretary of Robotics",
  },
  {
    id: 8,
    name: "BM Sayeed Sarwar Nehal",
    designation: "Secretary of Graphics",
  },
  {
    id: 9,
    name: "Md. Abdur Rahman Siam",
    designation: "Secretary of Gaming",
  },
  {
    id: 10,
    name: "Mishkat Mahiuddin",
    designation: "Secretary of Publication",
  },
  {
    id: 11,
    name: "Syeda Mashfi Rab",
    designation: "Secretary of Communication",
  },
  {
    id: 12,
    name: "Sardar Asif Ahmed",
    designation: "Joint Secretary",
  },
  {
    id: 13,
    name: "Md. Hafizur Rahman",
    designation: "Associate Secretary",
  },
  {
    id: 14,
    name: "Miftahul Zannat",
    designation: "Assistant Secretary of Programming & Robotics",
  },
  {
    id: 15,
    name: "Fatin Anjum Aishee",
    designation: "Assistant Secretary of Publication",
  },
  {
    id: 16,
    name: "Abdullah Al Anan",
    designation: "Assistant Secretary of Communication",
  },
];

const successorTeam = [
  {
    id: 1,
    name: "Mushfiqur Rahman",
    designation: "President",
  },
  {
    id: 2,
    name: "MD. Nazirul Islam",
    designation: "Vice President",
  },
  {
    id: 3,
    name: "Sk. Ruhin Razwan",
    designation: "General Secretary",
  },
  {
    id: 4,
    name: "MD. Miftahul Islam",
    designation: "Associate General Secretary",
  },
  {
    id: 5,
    name: "Mehmuna Haque Munia",
    designation: "Assistant General Secretary",
  },
  {
    id: 6,
    name: "Asif Hossain Khan",
    designation: "Secretary of Programming & Web Development",
  },
  {
    id: 7,
    name: " Israt Rahman Saif",
    designation: "Secretary of Robotics",
  },
  {
    id: 8,
    name: "Abrar Ahmed",
    designation: "Secretary of Graphics",
  },
  {
    id: 9,
    name: "Ishmam Azmine",
    designation: "Secretary of Gaming",
  },
  {
    id: 10,
    name: "Anisur Rahman",
    designation: "Secretary of Publication",
  },
  {
    id: 11,
    name: "Leamine Hossain",
    designation: "Associate Secretary ",
  },
  {
    id: 12,
    name: "Nawal Sadabee Rodela",
    designation: "Associate Secretary ",
  },
  {
    id: 13,
    name: "Farhan Labib",
    designation: "Assistant Secretary",
  },
  {
    id: 14,
    name: "Fahad Khan",
    designation: "Assistant Secretary of Programming & Robotics",
  },
  {
    id: 15,
    name: "Nafia Islam",
    designation: "Assistant Secretary of Publication",
  },
];

export { coreTeam, foundingTeam, successorTeam };
